import { type NotebookVersionChunksAndLatestRunningEvents } from "./models.server";

const thumbnailDomain = "https://assets.synthesize.bio/notebook-thumbnails";

export function getThumbnailUrl(templateSlug: string | null | undefined) {
  if (!templateSlug) {
    return `${thumbnailDomain}/default.png`;
  }
  return `${thumbnailDomain}/${templateSlug}.png`;
}

export function getRunningEventIdToFetchOutputFor(
  chunkData: NotebookVersionChunksAndLatestRunningEvents,
) {
  const { latestEventType, previousRunningEventId, latestRunningEventId } = chunkData;
  return latestEventType === "running" ? previousRunningEventId : latestRunningEventId;
}
